import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { UAParser } from 'ua-parser-js';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * 한국 시간(KST) 기준으로 현재 시각이 주어진 날짜/시각과 같거나 이후인지 여부
 * @param dateTimeString - 'YYYY-MM-DD' 또는 'YYYY-MM-DD HH:mm:ss' 형식 (KST)
 */
export function isTodayOnOrAfter(dateTimeString: string): boolean {
  const isDateTime = dateTimeString.includes(' ');
  const isoKST = isDateTime
    ? dateTimeString.replace(' ', 'T') + '+09:00'
    : dateTimeString + 'T00:00:00+09:00';
  const targetMs = new Date(isoKST).getTime();
  return Date.now() >= targetMs;
}

// 이벤트 페이지 날짜 형식 변환 함수
export function eventDatetimeToPeriod(
  startDatetime: string,
  endDatetime: string,
) {
  if (startDatetime.length === 0 && endDatetime.length === 0) {
    return '상시진행';
  } else if (startDatetime.length > 0 && endDatetime.length === 0) {
    return `${startDatetime} ~ 상시진행`;
  }
  return `${startDatetime} ~ ${endDatetime}`;
}

export function detectDevice() {
  const userAgent =
    typeof window !== 'undefined' ? window.navigator.userAgent : '';
  const parser = new UAParser(userAgent);
  const result = parser.getResult();
  const isIOS = result.os.name === 'iOS';
  const isAndroid = result.os.name === 'Android';

  return {
    isIOS,
    isAndroid,
    result,
  };
}
// 이슈  : ios도 android도 아닐 경우의 url은 어디로 ?
export function getDororoAppUrl() {
  const { isIOS, isAndroid } = detectDevice();
  return isIOS
    ? 'https://apps.apple.com/app/id6740759511'
    : isAndroid
      ? 'https://play.google.com/store/apps/details?id=kr.co.dororo'
      : 'https://play.google.com/store/apps/details?id=kr.co.dororo';
}
